module.exports = __webpack_public_path__ + "media/images/front/sp/atopy-control-check/img01-4b334cb73bf6407edad7f952ef03b071.png";